/** What caused a unit_pricing_history snapshot, in plain words. */
const SOURCE_LABELS = [
  [/extra charge/i, 'Extra charges changed'],
  [/plc/i, 'PLC changed'],
  [/accom/i, 'Accommodation changed'],
  [/pricing/i, 'Rate changed']
];

export function pricingHistorySource(source) {
  if (!source) return 'Price changed';
  const hit = SOURCE_LABELS.find(([re]) => re.test(String(source)));
  return hit ? hit[1] : String(source);
}

/** "Extra charges changed · 3 Oct 2026" */
export function pricingHistoryCaption(ph) {
  const when = ph?.created_at
    ? new Date(ph.created_at).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      })
    : null;
  return [pricingHistorySource(ph?.source), when].filter(Boolean).join(' · ');
}
